import * as React from 'react'
import { Text, Button, Block } from '$views/components'
import { isUserAuthenticated } from '$services/session/isAuthenticated/isAuthenticated.service'
import { Spinner } from '$views/components/Spinner'
import { createNewBroadcastService } from '$services/customer/broadcastService/broadcastService.service'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { formatError } from '$views/components/Error/Error.mapper'
import { ErrorView } from '$views/components/Error/Error.model'
import { Error } from '$views/components/Error'
import { tagManager } from '$infrastructure/tagManager/tagManager'
import { CareInformation } from '../components/CareInformation'
import { Location } from '../components/Location'
import { Formik, Form, Field } from 'formik'
import { serviceInformationValidator } from '$views/RecommendationsForms/BroadcastForm/ServiceInformationStep/ServiceInformationStep.validators'
import { draft } from '$utils/services/formDraftService'
import { broadcastFormDraftName, broadcastFormSteps } from '$views/RecommendationsForms/BroadcastForm/BroadcastForm'
import { PhoneNumber } from '$views/RecommendationsForms/BroadcastForm/components/PhoneNumber'
import { HoursPerWeek } from '$views/RecommendationsForms/BroadcastForm/components/HoursPerWeek'
import { Cared, caredText } from '$domain/model/cared/cared'
import { CareType } from '$views/RecommendationsForms/BroadcastForm/components/CareType'

interface Props {
  onNextStep: () => void
}

export const ServiceInformationStep: React.FC<Props> = ({ onNextStep }) => {
  const [isLoading, handleLoading] = React.useState<boolean>(false)
  const [errorNotification, setErrorNotification] = React.useState<ErrorView>()
  const [showErrorNotification, handleShowErrorNotification] = React.useState<boolean>(false)
  const [address, setAddress] = React.useState<string>('')

  const setErrors = errors => {
    setErrorNotification(errors)
    handleShowErrorNotification(true)
  }

  const onSubmit = async () => {
    if (isUserAuthenticated()) {
      tagManager.push({
        event: 'completeform',
        offerType: 'broadcast',
      })
      handleLoading(true)
      try {
        await createNewBroadcastService()
        history.push(routeProvider.broadcastFormConfirmation)
        handleLoading(false)
      } catch (error) {
        const broadcastError = formatError(error)
        setErrors(broadcastError)
        handleLoading(false)
      }
    } else {
      tagManager.push({
        event: 'completeform',
        offerType: 'broadcast',
      })
      onNextStep()
    }
  }

  const getButtonText = () => {
    if (isUserAuthenticated()) {
      return 'Empezar la búsqueda!'
    }
    return 'Siguiente (paso 1 de 2)'
  }

  const loadInitialValues = () => {
    const draftValues = draft.get(broadcastFormDraftName)
    return {
      careInformation: draftValues[broadcastFormSteps.serviceInformationStep.careInformation] || '',
      phoneNumber: draftValues[broadcastFormSteps.serviceInformationStep.phoneNumber] || '',
      careType: draftValues[broadcastFormSteps.serviceInformationStep.careType] || '',
      hoursPerWeek: draftValues[broadcastFormSteps.serviceInformationStep.hoursPerWeek] || '',
    }
  }

  const getAddressError = (errors: any, submitCount) => {
    if (errors.address && submitCount > 0) {
      return errors.address
    }
    return undefined
  }

  const updateAddressForValidation = (updateAddress, validateForm) => {
    setAddress(updateAddress)
    validateForm()
  }

  const getCaredTypes = () => {
    return Cared.types().map(cared => {
      cared.label = caredText[cared.label]
      return cared
    })
  }

  return (
    <>
      {isLoading && <Spinner />}
      {showErrorNotification && <Error error={errorNotification} onClick={() => handleShowErrorNotification(false)} />}
      <Text title>Te asesoramos</Text>
      <Text marginBottom="mini" marginTop="base">
        Déjanos tu teléfono y uno de nuestros asesores familiares te llamará cuanto antes para buscar la solución que
        mejor se adapte.
      </Text>
      <Formik
        initialValues={loadInitialValues()}
        onSubmit={onSubmit}
        validate={formValues => serviceInformationValidator(formValues, address)}
        render={({ errors, submitCount, validateForm }) => (
          <Form>
            <PhoneNumber />
            <Field
              component={CareType}
              name={broadcastFormSteps.serviceInformationStep.careType}
              list={getCaredTypes()}
            />
            <HoursPerWeek />
            <Location
              errorText={getAddressError(errors, submitCount)}
              updateAddressForExternalValidation={updateAddress =>
                updateAddressForValidation(updateAddress, validateForm)
              }
            />
            <CareInformation />
            <Block marginTop="small">
              <Button primary type="submit" fluid>
                {getButtonText()}
              </Button>
            </Block>
          </Form>
        )}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/ServiceInformationStep/ServiceInformationStep.tsx